import { addDomainAndTokenToUrl, restPatch, restPost } from '~/src/dash/api/rest';
import { EBool } from '~/src/dash/api/types/bool';
import { ECampaignDeliveryStatus } from '~/src/dash/components/filters/options/campaigns';
import { OrderDirectionType } from '~/src/dash/components/tables/common';

export type TDealListOrderByKey =
  | 'active'
  | 'deal_name'
  | 'external_deal_id'
  | 'partner'
  | 'deal_type'
  | 'deal_tier'
  | 'channels'
  | 'channel_groups'
  | 'revenue'
  | 'start_date'
  | 'end_date'
  | 'cpm'
  | 'bid_floor'
  | 'salesperson_id';

export interface IDealsListQueryParams {
  publisher_id: string;
  search: string; // back end will search on name, id
  page_size: number;
  page: number;
  order_direction: OrderDirectionType; // 'asc' | 'desc'
  order_by: TDealListOrderByKey;
  active: EBool;
  status: ECampaignDeliveryStatus[];
  timezone: string;
  start_date_from: string; // 'YYYY-MM-DD'
  start_date_to: string; // 'YYYY-MM-DD'
  end_date_from: string; // 'YYYY-MM-DD'
  end_date_to: string; // 'YYYY-MM-DD'
  deal_tiers: number[];
  salesperson_ids: number[];
  channel_ids: number[];
  channel_group_ids: number[];
  deal_types: number[];
  partners: string[];
  get_all?: boolean;
}
export interface ISimpleDeal {
  ID: number;
  Name: string;
  Active: EBool;
  StartDate: string; // YYYY-MM-DD
  EndDate: string; // YYYY-MM-DD
}

interface IDealsListResponse {
  deals: ISimpleDeal[];
  enrichmentErrors: string[];
  totalCount: number;
}

export async function getDealsList(
  publisherID: string,
  query: IDealsListQueryParams,
): Promise<IDealsListResponse> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/all_deals`);
  const response = await restPost<IDealsListResponse>(reqUrl, query);
  return (response?.parsedBody as IDealsListResponse) || {};
}

export async function updateDealActiveStatus(
  publisherID: string,
  dealID: number,
  query: Record<string, EBool>,
): Promise<IDealsListResponse> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/deal/${dealID}/active`);
  const response = await restPatch<IDealsListResponse>(reqUrl, query);
  return (response?.parsedBody as IDealsListResponse) || {};
}
